import type { FC } from "react";
import { Outlet, ScrollRestoration } from "react-router";
import { SiteFooter } from "./components/SiteFooter";
import { SiteHeader } from "./components/SiteHeader";
import { AuthGuard } from "./features/AuthGuard";

export const Layout: FC = () => (
  <AuthGuard>
    <div className="flex min-h-screen flex-col bg-white text-neutral-900 antialiased">
      <SiteHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
      <ScrollRestoration />
    </div>
  </AuthGuard>
);

export const PublicLayout: FC = () => (
  <div className="flex min-h-screen flex-col bg-white text-neutral-900 antialiased">
    <SiteHeader showLogout={false} />
    <main className="flex-1">
      <Outlet />
    </main>
    <SiteFooter />
    <ScrollRestoration />
  </div>
);
